export const getters = {
    adminRequestCurrent: state => state.adminRequestCurrent,
};
